<style lang="less">
  .dot,.dotM{
    .dot1,.dot2,.dot3{
      position: absolute;
    }
    .dot1{
      width:29px;height:20px;
      top: 66px;right: 18px;
    }
    .dot2{
      width:49px;height:43px;
      bottom: 90px;left: 18px;
    }
    .dot3{
      width: 97px;height:188px;
      bottom: -40px;right: 18px;
    }
  }
  .dotM{
    .dot1{
      width:59px;height:40px;
      top: 132px;right: 36px;
    }
    .dot2{
      width:98px;height:86px;
      bottom: 180px;left: 36px;
    }
    .dot3{
      width: 193px;height:376px;
      bottom: -79px;right: 36px;
    }
  }
</style>
<template>
  <div :class="isMobile?'dotM':'dot'">
    <img class="dot1" src="/s/publesson/images/cover_dot1.png">
    <img class="dot2" src="/s/publesson/images/cover_dot2.png">
    <img class="dot3" src="/s/publesson/images/cover_dot3.png">
  </div>
</template>
<script>
  export default{
    data(){
      return {
        isMobile: window.browserVersion.mobile,
      }
    }
  }
</script>
